const API_BASE_URL = process.env.API_BASE_URL ?? "";
const API_VERSION = process.env.API_VERSION ?? "v1";
function getMockKey(path) {
    const cleaned = path.replace(/^\/+/, "");
    const parts = cleaned.split("/");
    const first = parts[0].match(/^v\d+$/i) && parts.length > 1 ? parts[1] : parts[0];
    return first.replace(/\W+/g, "_").toUpperCase();
}
function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}
export async function fetchJson(path, options) {
    try {
        const key = getMockKey(path);
        const useMock = process.env[`USE_MOCK_FOR_${key}`] === "true";
        if (useMock) {
            const mockPath = process.env[`MOCK_FOR_${key}`];
            if (!mockPath)
                throw new Error(`Mock path missing for endpoint: ${key}`);
            const res = await fetch(mockPath);
            const data = (await res.json());
            await delay(1000);
            return { ok: true, data };
        }
        const res = await fetch(`${API_BASE_URL}/${API_VERSION}${path}`, options);
        if (!res.ok) {
            const text = await res.text();
            return { ok: false, error: `HTTP ${res.status}: ${text}` };
        }
        const data = (await res.json());
        return { ok: true, data };
    }
    catch (err) {
        return { ok: false, error: err.message };
    }
}
export async function getOptions({ getToken, tokenOptions = {}, method, body, }) {
    const bearerToken = await getToken(tokenOptions);
    if (!bearerToken) {
        throw new Error("Failed to get bearer token from Clerk");
    }
    const isFormData = body instanceof FormData;
    const headers = {
        Authorization: "Bearer " + bearerToken,
    };
    // Only set JSON content-type if NOT FormData
    if (!isFormData) {
        headers["Content-Type"] = "application/json";
    }
    const options = {
        method,
        headers,
    };
    if (body !== undefined) {
        options.body = isFormData ? body : JSON.stringify(body);
    }
    return options;
}
export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["get"] = "GET";
    HttpMethod["post"] = "POST";
    HttpMethod["put"] = "PUT";
    HttpMethod["patch"] = "PATCH";
    HttpMethod["delete"] = "DELETE";
    HttpMethod["options"] = "OPTIONS";
    HttpMethod["head"] = "HEAD";
})(HttpMethod || (HttpMethod = {}));
